import { render, staticRenderFns } from "./VisitorImageComponent.vue?vue&type=template&id=28ec50a1&scoped=true"
import script from "./VisitorImageComponent.vue?vue&type=script&lang=js"
export * from "./VisitorImageComponent.vue?vue&type=script&lang=js"
import style0 from "./VisitorImageComponent.vue?vue&type=style&index=0&id=28ec50a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec50a1",
  null
  
)

export default component.exports